import axios, { AxiosResponse } from "axios";
import { REACT_APP_API_BASE_URL } from "../ApiConfig";

// Extracts data from Axios response
const responseBody = <T>(response: AxiosResponse<T>): T => response.data;




const config = {
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': '*',
    'Access-Control-Allow-Headers': '*',
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  
  },
  timeout: 16000000
  
};

// Create axios instance with base config
const axiosInstance = axios.create({
  baseURL: REACT_APP_API_BASE_URL, // 🔁 moved to .env
  timeout: 16_000_000,
  headers: {
    'Access-Control-Allow-Origin': '*', 
    'Access-Control-Allow-Methods': '*',
    'Access-Control-Allow-Headers': '*',
    'Content-Type': 'application/json', 
    'Accept': 'application/json',
  },
});

// Simulate delay in development for testing
const sleep = (delay: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, delay));

// Response interceptor to add delay only in development
axiosInstance.interceptors.response.use(
  async (response) => {
    if (process.env.NODE_ENV === "development") {
      await sleep(1000);
    }
    return response;
  },
  (error) => Promise.reject(error)
);

// Generic request methods
const request = {
  get: <T>(url: string): Promise<T> => axiosInstance.get<T>(url).then(responseBody),
  post: <T>(url: string, body: unknown = {}): Promise<T> =>
    axiosInstance.post<T>(url, body).then(responseBody),
  put: <T>(url: string, body: unknown = {}): Promise<T> =>
    axiosInstance.put<T>(url, body).then(responseBody),
  delete: <T>(url: string): Promise<T> => axiosInstance.delete<T>(url).then(responseBody),
};

export { request, axiosInstance,config };

